import script from "./DevolucionesList.vue?vue&type=script&setup=true&lang=js"
export * from "./DevolucionesList.vue?vue&type=script&setup=true&lang=js"

import "./DevolucionesList.vue?vue&type=style&index=0&id=5419beac&scoped=true&lang=css"

import exportComponent from "/home/runner/work/jeanInformatico-management-system/jeanInformatico-management-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5419beac"]])

export default __exports__